export class ErrorConfig {
  apiEndpoint!: string;
}
